import React, { useEffect, useRef } from "react";
// Note: Select2 and jQuery is loaded via Rails asset pipeline

const Select2Wrapper = ({ items, options, onChange, useDirectParent, value, ...props }) => {
  const selectRef = useRef(null);
  const isSyncingRef = useRef(false);

  useEffect(() => {
    const $select = window.$(selectRef.current); // use global jQuery

    // Initialize Select2 (Rails-loaded)
    if ($select.data("select2")) {
      $select.select2("destroy");
      $select.off(".select2wrapper");
    }
    $select.select2({
      ...options,
      dropdownParent: useDirectParent ? $select.parent() : window.$(document.body),
      dropdownAutoWidth: !0,
      width: "100%",
    });

    // Handle user-triggered changes
    $select.on('change.select2wrapper', (e) => {
      if (isSyncingRef.current) return; // prevent loops
      onChange?.(e);
    });

    // Set initial value
    if (value !== undefined && value !== null) {
      isSyncingRef.current = true;
      $select.val(value).trigger('change', { internal: true });
      isSyncingRef.current = false;
    }

    // Cleanup on unmount
    return () => {
      $select.off('.select2wrapper');
      $select.select2('destroy');
    };
  }, [items]);

  // Sync external value changes (without looping)
  useEffect(() => {
    const $select = window.$(selectRef.current);
    if (!$select.data('select2')) return;

    const normalize = (input) => {
      if (options?.multiple) {
        input = input || [];
        return input.map(String);
      }
      if (!input) {
        return null;
      }
      return String(input);
    }

    const currentVal = normalize($select.val());
    const newVal = normalize(value);

    // shallow compare arrays or strings
    const same =
      Array.isArray(currentVal) && Array.isArray(newVal)
        ? currentVal.length === newVal.length &&
          currentVal.every((v, i) => v === newVal[i])
        : currentVal === newVal;

    if (!same) {
      isSyncingRef.current = true;
      $select.val(newVal).trigger('change', { internal: true });
      isSyncingRef.current = false;
    }
  }, [value]);

  return (
    <select ref={selectRef} {...props}>
      {options?.placeholder && <option value="">{options.placeholder}</option>}
      {items && items.map(item =>
        <option key={item.value} value={item.value}>{item.label}</option>
      )}
    </select>
  );
};

export default Select2Wrapper;
